import { render, staticRenderFns } from "./KpiCard.vue?vue&type=template&id=e7d27a68&scoped=true&"
import script from "./KpiCard.vue?vue&type=script&lang=js&"
export * from "./KpiCard.vue?vue&type=script&lang=js&"
import style0 from "./KpiCard.vue?vue&type=style&index=0&id=e7d27a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d27a68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VIcon,VSkeletonLoader})
